import { render, staticRenderFns } from "./MagazzinoArticoliCodiciLottoMatricoleListComponent.vue?vue&type=template&id=410cd2fc&scoped=true"
import script from "./MagazzinoArticoliCodiciLottoMatricoleListComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliCodiciLottoMatricoleListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410cd2fc",
  null
  
)

export default component.exports